var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\xE5\xBD\xA2\xE7\x8A\xB6",
    d: "M13.5374 6.99989C13.5374 10.5345 10.507 13.4 6.7686 13.4C3.03022 13.4 0 10.5353 0 6.99989C0 3.4644 3.03046 0.599976 6.7686 0.599976C10.5067 0.599976 13.5374 3.46526 13.5374 6.99989ZM20.9629 6.99989C20.9629 10.3273 19.4476 13.0244 17.5785 13.0244C15.7094 13.0244 14.1941 10.3264 14.1941 6.99989C14.1941 3.67333 15.7094 0.97532 17.5785 0.97532C19.4476 0.97532 20.9629 3.67333 20.9629 6.99989ZM24 6.99989C24 9.98106 23.467 12.3977 22.8097 12.3977C22.1523 12.3977 21.6193 9.98021 21.6193 6.99989C21.6193 4.01954 22.1523 1.60213 22.8099 1.60213C23.4674 1.60213 24 4.01889 24 6.99989Z",
    fill: "black",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.a716338a03fc4379ed65c84288e98486.svg";
export { ForwardRef as ReactComponent };